<template>
  <div class="page">
    <div class="toolbar">
      <el-input v-model="kw" placeholder="搜索标题…" clearable @change="fetchList(1)" style="max-width:280px" />
      <el-button type="primary" @click="fetchList(1)">刷新</el-button>

    </div>

    <el-table :data="items" stripe style="width:100%">
      <el-table-column label="封面" width="90">
        <template #default="{ row }">
          <img :src="row.cover_url || defaultCover" class="cover" />
        </template>
      </el-table-column>
      <el-table-column label="标题" min-width="240">
        <template #default="{ row }">
          <div class="title">{{ row.title }}</div>
          <div class="sub">{{ row.genre }} · {{ row.style }} · {{ row.platform }} · {{ row.language }}</div>
        </template>
      </el-table-column>
      <el-table-column label="章节" width="120" align="center">
        <template #default="{ row }">
          <div>{{ row.chapters_done }}/{{ row.chapters_total || row.chapter_plan }}</div>
        </template>
      </el-table-column>
      <el-table-column label="进度" min-width="220">
        <template #default="{ row }">
          <el-progress :percentage="Number(row.percent || 0)" :text-inside="true" :stroke-width="18" />
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="660">
        <template #default="{ row }">
          <el-button size="small" type="primary" @click="startPipeline(row)" :loading="row._starting">启动</el-button>
          <el-button size="small" @click="refreshStatus(row)">查询进度</el-button>
          <el-divider direction="vertical" />
          <el-button size="small" @click="openChapters(row)">查看章节</el-button>
          <el-button size="small" @click="openReader(row)">阅读全文</el-button>
          <el-button size="small" @click="downloadZip(row)">打包下载</el-button>
          <el-divider direction="vertical" />
          <el-button size="small" @click="showInspiration(row)">灵感</el-button>
          <el-button size="small" @click="showOutline(row)">大纲</el-button>
          <el-divider direction="vertical" />
          <el-button size="small" @click="editConfig(row)">编辑条件</el-button>
          <el-divider direction="vertical" />
          <el-button size="small" type="danger" @click="deleteNovel(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager">
      <el-pagination background layout="prev, pager, next, jumper, total" v-model:current-page="page" :page-size="ps"
        :total="total" @current-change="fetchList" />

    </div>

    <!-- 编辑条件 -->
    <el-drawer v-model="showEdit" title="编辑小说条件" size="50%">
      <el-form :model="editForm" label-width="100px" class="form">
        <el-form-item label="标题"><el-input v-model="editForm.title" /></el-form-item>
        <el-form-item label="平台"><el-input v-model="editForm.platform" /></el-form-item>
        <el-form-item label="语言"><el-input v-model="editForm.language" /></el-form-item>
        <el-form-item label="题材"><el-input v-model="editForm.genre" /></el-form-item>
        <el-form-item label="风格"><el-input v-model="editForm.style" /></el-form-item>
        <el-form-item label="篇幅章节"><el-input-number v-model="editForm.chapter_plan" :min="10"
            :max="600" /></el-form-item>
        <el-form-item><el-button type="primary" @click="saveEdit">保存</el-button></el-form-item>
      </el-form>
    </el-drawer>

    <!-- 灵感 -->
    <el-dialog v-model="showInsp" width="60%" :title="'灵感 · ' + (current?.title || '')">
      <pre class="mono">{{ inspiration }}</pre>
      <template #footer><el-button @click="showInsp = false">关闭</el-button></template>
    </el-dialog>

    <!-- 大纲 -->
    <el-dialog v-model="showOL" width="70%" :title="'大纲 · ' + (current?.title || '')">
      <h4>单元</h4>
      <pre class="mono">{{ outline.units_outline }}</pre>
      <h4>章节细纲</h4>
      <pre class="mono">{{ outline.chapters_outline }}</pre>
      <template #footer><el-button @click="showOL = false">关闭</el-button></template>
    </el-dialog>

    <!-- 章节抽屉 -->
    <el-drawer v-model="showChap" size="60%" :title="'章节 · ' + (current?.title || '')">
      <el-table :data="chapters" size="small" height="60vh" :row-key="r => r.id">
        <el-table-column prop="chapter_index" label="#" width="60" />
        <el-table-column prop="title" label="标题" min-width="220" />
        <el-table-column prop="word_count" label="字数" width="80" align="center" />
        <el-table-column prop="update_time" label="更新时间" width="160" />
        <el-table-column label="操作" width="260">
          <template #default="{ row }">
            <el-button size="small" @click="readOne(row)">阅读</el-button>
            <el-button size="small" @click="askRewrite(row)">重写</el-button>
            <el-button size="small" @click="askContinue(row)">续写</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="oneChapter" class="reader">
        <h3>{{ oneChapter.title }}</h3>
        <pre class="mono">{{ oneChapter.content || '（暂无正文）' }}</pre>
      </div>
    </el-drawer>

    <!-- 提示输入 -->
    <el-dialog v-model="showPrompt" :title="promptTitle" width="480px">
      <el-input v-model="prompt" type="textarea" :rows="5" placeholder="可填补充要求/方向（可留空）" />
      <template #footer>
        <el-button @click="showPrompt = false">取消</el-button>
        <el-button type="primary" @click="submitPrompt">确定</el-button>
      </template>
    </el-dialog>

    <!-- 阅读器 -->
    <el-dialog v-model="showReader" width="70%" :title="'阅读 · ' + (current?.title || '')">
      <div class="reader-tools">
        每页字数：
        <el-input-number v-model="pageChars" :min="500" :max="4000" :step="100" size="small" />
        <el-button size="small" @click="pageIndex = Math.max(1, pageIndex - 1)">上一页</el-button>
        <el-button size="small" @click="pageIndex = Math.min(pageCount, pageIndex + 1)">下一页</el-button>
        <span class="muted">第 {{ pageIndex }} / {{ pageCount }} 页</span>
      </div>
      <div class="reader-box">
        <pre class="mono">{{ pageText }}</pre>
      </div>
      <template #footer><el-button @click="showReader = false">关闭</el-button></template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie'
import config from '@/config'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRoute } from 'vue-router'

const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
const storeId = userInfo.id || 0

const kw = ref('')
const items = ref([])
const page = ref(1)
const ps = 20
const total = ref(0)
const defaultCover = 'https://dummyimage.com/80x106/eee/aaa&text=Cover'

const route = useRoute()

async function openFromQuery() {
  const qNovelId = Number(route.query.novel_id || 0)
  const qChapterId = Number(route.query.chapter_id || 0)
  if (!qNovelId) return

  // 先在当前页数据里找
  let row = items.value.find(i => Number(i.id) === qNovelId)

  // 不在当前页就尝试补 details（可选）
  if (!row) {
    try {
      const { data } = await axios.get(`${config.BASE_URL}/shop/api/novel_detail_api.php`, {
        params: { action: 'get', store_id: storeId, novel_id: qNovelId }
      })
      if (data.code === 200) row = data.data
    } catch (e) {
      void e
    }
  }

  // 兜底
  if (!row) row = { id: qNovelId, title: `#${qNovelId}` }
  current.value = row

  // 1) 总是先打开并加载“章节列表”
  await openChapters(row)

  // 2) 如带 chapter_id，再补拉该单章正文显示在右侧阅读区
  if (qChapterId) {
    const { data } = await axios.get(`${config.BASE_URL}/shop/api/novel_chapter_apis.php`, {
      params: { action: 'get', chapter_id: qChapterId }
    })
    if (data.code === 200) {
      oneChapter.value = data.data
      // showChap 已在 openChapters 里设为 true，这里不必重复设置
    }
  }
}



function pickList(resp) {
  // 兼容后端不同字段名：items / list / rows / data本身是数组
  return resp?.data?.items
    ?? resp?.data?.list
    ?? resp?.data?.rows
    ?? (Array.isArray(resp?.data) ? resp.data : [])
}

async function fetchList(p = page.value) {
  page.value = p
  const { data } = await axios.get(`${config.BASE_URL}/shop/api/novel_list_api.php`, {
    params: { action: 'list', store_id: storeId, page: page.value, page_size: ps, kw: kw.value }
  })
  if (data.code === 200) { items.value = data.data.items; total.value = data.data.total }
}

async function refreshStatus(row) {
  const { data } = await axios.get(`${config.BASE_URL}/shop/api/novel_list_api.php`, { params: { action: 'status', store_id: storeId, novel_id: row.id } })
  if (data.code === 200) {
    row.chapters_total = data.data.chapters_total
    row.chapters_done = data.data.chapters_done
    row.percent = data.data.percent
    ElMessage.success('已刷新')
  }
}
async function deleteNovel(row) {
  try {
    await ElMessageBox.confirm(
      `确定要删除《${row.title}》吗？此操作将同时删除所有章节和任务，且不可恢复！`,
      '警告',
      { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
    )

    const { data } = await axios.post(`${config.BASE_URL}/shop/api/novel_list_api.php`, {
      action: 'delete',
      store_id: storeId,
      novel_id: row.id
    })

    if (data.code === 200) {
      ElMessage.success('删除成功')
      fetchList(page.value) // 刷新当前页
    } else {
      ElMessage.error(data.message || '删除失败')
    }
  } catch (e) {
    if (e !== 'cancel') {
      ElMessage.error('删除操作取消或失败')
    }
  }
}

async function startPipeline(row) {
  try {
    row._starting = true
    const { data } = await axios.post(`${config.BASE_URL}/shop/api/novel_pipeline_api.php`, { action: 'start', store_id: storeId, novel_id: row.id })
    if (data.code === 200) { ElMessage.success('已启动'); await refreshStatus(row) } else { ElMessage.error(data.message || '启动失败') }
  } finally { row._starting = false }
}

/* —— 编辑条件 —— */
const showEdit = ref(false)
const editForm = reactive({})
const current = ref(null)
function editConfig(row) {
  current.value = row
  Object.assign(editForm, row)
  showEdit.value = true
}
async function saveEdit() {
  const { data } = await axios.post(`${config.BASE_URL}/shop/api/novel_list_api.php`, { action: 'update', store_id: storeId, novel_id: current.value.id, ...editForm })
  if (data.code === 200) { ElMessage.success('已保存'); showEdit.value = false; fetchList() } else { ElMessage.error(data.message || '保存失败') }
}

/* —— 灵感/大纲 —— */
const showInsp = ref(false)
const inspiration = ref('')
async function showInspiration(row) {
  current.value = row
  const { data } = await axios.get(`${config.BASE_URL}/shop/api/novel_list_api.php`, { params: { action: 'inspiration', novel_id: row.id, store_id: storeId } })
  inspiration.value = data.data?.inspiration || ''
  showInsp.value = true
}

const showOL = ref(false)
const outline = reactive({ units_outline: '', chapters_outline: '' })
async function showOutline(row) {
  current.value = row
  const { data } = await axios.get(`${config.BASE_URL}/shop/api/novel_list_api.php`, { params: { action: 'outline', novel_id: row.id, store_id: storeId } })
  outline.units_outline = data.data?.units_outline || ''
  outline.chapters_outline = data.data?.chapters_outline || ''
  showOL.value = true
}

/* —— 章节抽屉 —— */
const showChap = ref(false)
const chapters = ref([])
const oneChapter = ref(null)

async function openChapters(row) {
  current.value = row
  const { data } = await axios.get(`${config.BASE_URL}/shop/api/novel_chapter_apis.php`, {
    params: { action: 'list', store_id: storeId, novel_id: row.id }
  })
  chapters.value = pickList(data)
  showChap.value = true
  oneChapter.value = null
}

async function readOne(ch) {
  const { data } = await axios.get(`${config.BASE_URL}/shop/api/novel_chapter_apis.php`, { params: { action: 'get', chapter_id: ch.id } })
  if (data.code === 200) { oneChapter.value = data.data } else { ElMessage.error('获取失败') }
}

const showPrompt = ref(false)
const promptTitle = ref('')
const prompt = ref('')
let promptAct = ''
let promptChapId = 0
function askRewrite(ch) {
  promptAct = 'rewrite'; promptChapId = ch.id; promptTitle.value = `重写：${ch.title}`; prompt.value = ''
  showPrompt.value = true
}
function askContinue(ch) {
  promptAct = 'continue'; promptChapId = ch.id; promptTitle.value = `续写：${ch.title}`; prompt.value = ''
  showPrompt.value = true
}
async function submitPrompt() {
  const { data } = await axios.post(`${config.BASE_URL}/shop/api/novel_chapter_apis.php`, { action: promptAct, store_id: storeId, novel_id: current.value.id, chapter_id: promptChapId, prompt: prompt.value })
  if (data.code === 200) { ElMessage.success('任务已入队（后台处理）'); showPrompt.value = false } else { ElMessage.error(data.message || '提交失败') }
}

/* —— 阅读器（整书） —— */
const showReader = ref(false)
const allChapters = ref([])
const pageChars = ref(1200)
const pageIndex = ref(1)
const pageCount = computed(() => {
  const totalChars = allChapters.value.reduce((s, c) => s + (c.content?.length || 0), 0)
  return Math.max(1, Math.ceil(totalChars / pageChars.value))
})
const pageText = computed(() => {
  const chunk = []
  let need = pageChars.value
  let passed = (pageIndex.value - 1) * pageChars.value
  for (const c of allChapters.value) {
    const t = `【${c.title}】\n\n${c.content || ''}\n\n`
    if (passed >= t.length) { passed -= t.length; continue }
    const start = passed; const slice = t.slice(start, start + need)
    chunk.push(slice); need -= slice.length; passed = 0
    if (need <= 0) break
  }
  return chunk.join('')
})

async function openReader(row) {
  current.value = row
  const { data } = await axios.get(`${config.BASE_URL}/shop/api/novel_chapter_apis.php`, {
    params: { action: 'full_json', store_id: storeId, novel_id: row.id }
  })
  // full_json 若没做，也可退化用 list 再拼接；先统一取出数组
  let arr = pickList(data)
  // 有些接口把 content 放在 data.list；如果没有 content，就只看已完成章节再逐章补拉（可选）
  if (arr.length && arr.every(c => !c.content)) {
    // 只取 status=2 的章节，减少额外请求（可选优化）
    const done = arr.filter(c => Number(c.status) === 2)
    // 并发拉正文（注意：如果章节很多，这里也可以不拉，直接用 list 的 content）
    await Promise.all(done.map(async c => {
      const { data: d2 } = await axios.get(`${config.BASE_URL}/shop/api/novel_chapter_apis.php`, { params: { action: 'get', chapter_id: c.id } })
      if (d2.code === 200 && d2.data) Object.assign(c, d2.data)
    }))
    arr = done
  }
  allChapters.value = arr
  pageIndex.value = 1
  showReader.value = true
}

/* —— 打包下载 —— */
async function downloadZip(row) {
  const { data } = await axios.get(`${config.BASE_URL}/shop/api/novel_export_api.php`, { params: { action: 'zip_txt', store_id: storeId, novel_id: row.id } })
  if (data.code === 200 && data.data?.url) {
    window.open(data.data.url, '_blank')
  } else {
    ElMessage.error(data.message || '打包失败')
  }
}

onMounted(() => {
  fetchList(1).then(openFromQuery)
})

</script>

<style scoped>
.page {
  padding: 16px;
}

.toolbar {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.cover {
  width: 60px;
  height: 80px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #eee;
}

.title {
  font-weight: 600;
}

.sub {
  color: #888;
  font-size: 12px;
}

.mono {
  white-space: pre-wrap;
  word-break: break-word;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.pager {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.reader {
  margin-top: 12px;
  padding: 12px;
  background: #fafafa;
  border: 1px solid #eee;
}

.reader-tools {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.reader-box {
  height: 60vh;
  overflow: auto;
  padding: 12px;
  background: #fff;
  border: 1px solid #eee;
}

.muted {
  color: #888;
  font-size: 12px;
}

.el-message-box {
  max-width: 80%;
}
</style>
